const navElements = document.querySelectorAll(".js-nav");

window.addEventListener("DOMContentLoaded", () => {
  navElements.forEach((navElement) => {
    navElement.addEventListener("click", function () {
      this.classList.toggle("is-open");
      const nextElement = this.nextElementSibling;
      nextElement.classList.toggle("is-open");
      if (navElement.classList.contains("is-open")) {
        nextElement.style.height = nextElement.scrollHeight + "px";
      } else {
        nextElement.style.height = "0";
      }
    });
  });
});
